import { Label, Layout, Panel, Textbox, Tree } from "@mcleod/components";

export abstract class AutogenLayoutPermissionsMain extends Layout {
    labelPageTitle: Label;
    layoutPermsGrant: Layout;
    panelMain: Panel;
    textSearchMenu: Textbox;
    treeMenu: Tree;
}
